import React, { Fragment, Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select, Row, Input } from 'antd';
import { isAlive } from 'mobx-state-tree';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { SettingsFormHeader } from '../../../../common/SettingsFormHeader';
import { FormItem } from '../../styled';
import { config } from '../../config';
import Button from '../../../../common/Button';

const { Option } = Select;

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customEntry: false
    }
    this.handlePolicy = this.handlePolicy.bind(this);
  }
  componentWillUnmount() {
    const { ebayPaymentPolicies } = this.props;
    if (isAlive(ebayPaymentPolicies)) {
      ebayPaymentPolicies.cancelFormSelection();
    }
  }

  handlePolicy() {
    const { isCreateAction, ebayPaymentPolicies, close } = this.props;
    if (isCreateAction) {
      ebayPaymentPolicies.createNewPolicy().then(() => close());
    } else {
      ebayPaymentPolicies.updatePolicy();
    }
  }

  render() {
    const { intl, isCreateAction, ebayPaymentPolicies, close } = this.props;
    const { customEntry } = this.state;
    const formItemLayout = config.editPolicyItemLayout;
    return (
      <Fragment>
        <SettingsFormHeader id="listing.payment" defaultMessage="Payment" />
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.setPolicyName" defaultMessage="Policy Name" />}
          fullWidth
        >
          <Input
            type="text"
            onChange={ebayPaymentPolicies.setPolicyName}
            value={ebayPaymentPolicies.name}
          />
        </FormItem>
        <FormItem
          fullWidth
          {...formItemLayout}
          label={
            <FormattedMessage
              id="listing.paypalAccountForAcceptingPayments"
              defaultMessage="PayPal Account for Accepting Payments"
            />
          }
        >
          <Select
            placeholder={intl.formatMessage({id:'listing.startTyping'})}
            onInputKeyDown={e=>{
              if(ebayPaymentPolicies.account) {
                e.preventDefault();
              } else if(!customEntry){
                this.setState({
                  customEntry: true
                })
              }
            }}
            onChange={value => {
              let objValue;
              if(customEntry) {
                objValue = {
                  name: value[0],
                  id: ''
                }
              } else {
                objValue = value.length ?
                  JSON.parse(value[value.length - 1]) :
                  {id: null};
              }
              if(objValue.id === null) {
                ebayPaymentPolicies.setAccount('');
              } else {
                ebayPaymentPolicies.setAccount(objValue.name)
              }
              this.setState({
                customEntry: false
              })
            }}
            value={ebayPaymentPolicies.account ? [ebayPaymentPolicies.account] : []}
            mode="tags"
          >
            {ebayPaymentPolicies.account && (
              <Option key='other' value={JSON.stringify({id: null})}>
                <span style={{fontFamily: 'Heebo-Thin'}}>{intl.formatMessage({id:'listing.useOther'})}</span>
              </Option>
            )}
            {ebayPaymentPolicies.paypalAccounts
              .map(({ id, name }) => (
                <Option key={id} value={JSON.stringify({ id, name })}>
                  {name}
                </Option>
              ))
            }
          </Select>
        </FormItem>
        <Row style={{ justifyContent: 'flex-end', marginTop: '40px' }}>
          <Button
            htmlType="submit"
            type="normal"
            clickHandler={this.handlePolicy}
            disabled={ebayPaymentPolicies.isButtonDisabled}
            cssProps={{ marginRight: '5px' }}
          >
            {intl.formatMessage({
              id: isCreateAction ? 'listing.createPolicy' : 'common.save',
            })}
          </Button>
          <Button
            type="normal"
            clickHandler={close}
          >
            {intl.formatMessage({ id: 'common.cancel' })}
          </Button>
        </Row>
      </Fragment>
    );
  }
}

PaymentForm.propTypes = {
  isCreateAction: PropTypes.bool,
  ebayPaymentPolicies: PropTypes.object,
  intl: PropTypes.object,
  close: PropTypes.func,
};

export default injectIntl(observer(PaymentForm));
